// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import lodashGet from 'lodash/get'

import { isMSP } from '../../../../../../utils/feature-flag-utils'
import { policyTypeEnum } from '../../../../../../utils/constants'

export const validateGeneralFields = (formValues, t) => {
  const requiredString = t('iam:sso_profiles.view_edit_create.required')
  const mspApplication = lodashGet(formValues, 'general.mspApplication')
  const policyType = lodashGet(formValues, 'general.policyType')
  const ssoConnections = lodashGet(formValues, 'general.ssoConnections')
  const domain = lodashGet(formValues, 'general.domain')
  const authorizationMode = lodashGet(formValues, 'general.authorizationMode')
  const acknowledgement = lodashGet(formValues, 'general.acknowledgement') || []
  const hasAcknowledged =
    policyType === policyTypeEnum.DOMAIN_EXTERNAL &&
    authorizationMode === 'SSO role assignments'
      ? !!acknowledgement.length
      : true

  const formValid = isMSP()
    ? (policyTypeEnum.DOMAIN_EXTERNAL ||
        (policyTypeEnum.DOMAIN_VERIFIED && ssoConnections)) &&
      domain &&
      authorizationMode &&
      hasAcknowledged &&
      mspApplication?.length > 0
    : (policyTypeEnum.DOMAIN_EXTERNAL ||
        (policyTypeEnum.DOMAIN_VERIFIED && ssoConnections)) &&
      domain &&
      authorizationMode &&
      hasAcknowledged

  return {
    mspApplication: mspApplication?.length > 0 ? '' : requiredString,
    policyType: policyType ? '' : requiredString,
    ssoConnections: ssoConnections ? '' : requiredString,
    domain: domain ? '' : requiredString,
    authorizationMode: authorizationMode ? '' : requiredString,
    acknowledgement: acknowledgement.length > 0 ? '' : requiredString,
    isValid: formValid
  }
}
